import {Component, Input} from '@angular/core';
import {DamElasticDTO, DamRelatedCollection} from "compob2b-libs";
import {CrudConfig} from "../../../../../admin-shared/interfaces/crud.config";

@Component({
  selector: 'app-attached-elements',
  templateUrl: './attached-elements.component.html',
  styleUrls: ['./attached-elements.component.scss']
})
export class AttachedElementsComponent {
  @Input() damElements: DamElasticDTO[] = [];

  @Input()
  damRelatedCollection: DamRelatedCollection[];

  @Input()
  controllerUri: string;
  /**
   * Configures fields
   * Set in child component class
   */
  @Input()
  config: CrudConfig;

  /**
   * Backend CRUD uri
   * Set in child component class
   */
  @Input()
  uri: string;

  @Input()
  model: any;

}
